import React, { useState, useEffect } from 'react';
import { TextInput } from '../../../../ui/InputFields';


interface CurrencyInputProps {
  value: string | number;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  height?: string;
  maxWidth?: string;
  border?: string;
  padding?: string;
  leftIcon?: boolean;
  isIcopn?: boolean;
  isDiabled?: boolean
}

export const CurrencyInput: React.FC<CurrencyInputProps> = ({
  value,
  onChange,
  onValueChange,
  placeholder,
  disabled,
  height,
  maxWidth,
  border,
  padding,
  leftIcon = true,
  isIcopn = true,
  isDiabled = false
}) => {
  const [displayValue, setDisplayValue] = useState(value ? String(value) : '');

  useEffect(() => {
    if (value !== displayValue.replace(/[^\d]/g, '')) {
      setDisplayValue(String(value || ''));
    }
  }, [value]);

  const handleChange = (inputValue: string) => {
    const rawValue = inputValue.replace(/[^\d]/g, '');
    setDisplayValue(rawValue);
    onChange(rawValue);
  };

  const handleBlur = () => {
    if (displayValue) {
      setDisplayValue(`${Number(displayValue).toLocaleString()}`);
    }
  };

  const handleFocus = () => {
    setDisplayValue(displayValue.replace(/[^\d]/g, ''));
  };

  return (
    <TextInput
      type="text"
      value={displayValue}
      placeholder={placeholder}
      disabled={disabled}
      height={height}
      maxWidth={maxWidth}
      border={border}
      padding={padding}
      leftIcon={leftIcon}
      isIcopn={isIcopn}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      readOnly={isDiabled}
    />
  );
};
